<template lang="pug">
  section.section
    Loader(v-show="isLoading")
    .container
      .columns
        .column.is-3
          .field
            label.label Marcas
            .control
              typeahead(:options="marcas" :optionSelect="itemMarcaSel" v-model="itemMarcaSel")
        .column.is-3
          .field
            label.label Modelo
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Modelo',
                v-model="modelo",
              )
        .column.is-3
          .field
            label.label Tipo
            .control
              typeahead(:options="tipos" :optionSelect="itemSel" v-model="itemSel")
        .column.is-3
          .field
            label.label Codigo
            .control
              input.input.is-primary(
                type='text', 
                placeholder='Codigo',
                v-model="codigo",
              )
      .columns(v-show="datosFaltantes.length > 0")
        .column.is-12
          .notification
            .field.is-grouped.is-grouped-multiline
              .control(v-for="datosF in datosFaltantes")
                .tags
                  span.tag.is-danger.is-light {{ datosF }}
      .colunms
        .column.is-2
          a.button.is-black.is-rounded(:disabled="isDisabled" @click="checkForm")
            | Guardar
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import InventarioServices from '../../services/inventario/inventario';
  import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'FormArticulos_Base',
    components: { Loader, Typeahead },
    data() {
      return {
        isLoading: true,
        marca: null,
        modelo: null,
        codigo: null,
        tipos: [],
        marcas: [],
        itemSel: {},
        itemMarcaSel: {},
        datosFaltantes: [],
        isDisabled: true,
      }
    },
    watch: {
      itemSel() {
        this.searchArticuloBase()
      },

      itemMarcaSel () {
        this.searchArticuloBase()
      },

      modelo () {
        this.searchArticuloBase()
      },
    },
    methods: {
      inciarComponente() {
        this.obtenerMarcas()
      },
      obtenerMarcas() {
        InventarioServices.getMarcas()
          .then(res => {
            this.marcas = res.data.map(this.convertirMarcas)
            this.obtenerTipos()
          })
      },
      convertirMarcas (marca) {
        return {
          ...marca,
          text: marca.nombre
        }
      },
      obtenerTipos () {
        InventarioServices.getCats_Subcats()
          .then(res => {
            this.tipos = res.map(this.convetirTipos)
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      },
      convetirTipos(item) {
        return {
          ...item,
          text: `${item.categoria} ${item.subcategoria}`
        }
      },
      checkForm () {
        if (this.isDisabled) {
          return
        }

        this.datosFaltantes = []
        if (Object.keys(this.itemMarcaSel).length > 0 && this.modelo && Object.keys(this.itemSel).length > 0) {
          this.saveForm()
        } else {
          
          if (Object.keys(this.itemMarcaSel).length == 0) {
            this.datosFaltantes.push('La marca del artículo es requerida.')
          }

          if (!this.modelo) {
            this.datosFaltantes.push('El modelo del artículo es requerido.')
          }

          if (Object.keys(this.itemSel).length == 0) {
            this.datosFaltantes.push('El tipo de artículo es requerido.')
          }
        }
      },
      saveForm () {
        let myObj = {
          marca: this.itemMarcaSel.nombre,
          modelo: this.modelo,
          id_cat: this.itemSel.id,
          categoria: this.itemSel.categoria,
          id_subcat: this.itemSel.id_sub,
          subcategoria: this.itemSel.subcategoria,
          codigo: this.codigo
        }
        this.$emit('saveForm', myObj)
      },
      searchArticuloBase () {
        if (Object.keys(this.itemSel).length < 1) {
          return
        }

        if (Object.keys(this.itemMarcaSel).length < 1) {
          return
        }

        const _modelo = this.modelo ? this.modelo : ''
        InventarioServices.buscarArticuloBase(this.itemMarcaSel.nombre, _modelo, this.itemSel.id, this.itemSel.id_sub)
          .then( data => {
            const existe = parseInt(data[0].existe) == 1 ? true : false
            this.isDisabled = existe
            if (existe) {
              this.displayToast('bubble', 'Ya existe un artículo con estas características.')
            }
          })
          .catch( e => {
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.inciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/FormArticulos_Base.vue